import React from "react";
import { Box } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

const fillProgress = keyframes`
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
`;

const Dot = styled(Box, { shouldForwardProp: (p) => p !== "active" && p !== "past" })(
  ({ active, past }) => ({
    width: active ? 24 : 8,
    height: 8,
    borderRadius: active ? 4 : "50%",
    backgroundColor: past ? "#2ec4b6" : "transparent",
    border:
      active ? "1px solid rgba(46,196,182,0.5)" :
      past ? "none" :
      "2px solid rgba(0,0,0,0.2)",
    overflow: "hidden",
    position: "relative",
    transition: "width 0.35s cubic-bezier(.4,0,.2,1)",
  })
);

const Fill = styled(Box, { shouldForwardProp: (p) => p !== "holdMs" })(({ holdMs }) => ({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: "#2ec4b6",
  transformOrigin: "left center",
  transform: "scaleX(0)",
  animation: `${fillProgress} ${holdMs}ms linear forwards`,
}));

const Row = styled(Box)({
  display: "flex",
  gap: 6,
  justifyContent: "center",
  alignItems: "center",
  padding: 12,
});

const ProgressDots = ({ total, currentIndex, holdMs = 8000 }) => {
  if (!total || total <= 0) return null;
  return (
    <Row>
      {Array.from({ length: total }).map((_, i) => {
        const active = i === currentIndex;
        const past = i < currentIndex;
        return (
          <Dot key={i} active={active} past={past}>
            {active && <Fill key={currentIndex} holdMs={holdMs} />}
          </Dot>
        );
      })}
    </Row>
  );
};

export default ProgressDots;
